import NetworkPage from '@modules/professional/page/NetworkPage';
import { loader } from '@modules/professional/page/loaders/network-page-loader.server';
import type { APHandle } from '~/modules/root';
import { inheritMeta } from '~/modules/seo';
export { inheritMeta as meta };

export const handle: APHandle = {
    category: 'professional',
    allowFilters: true,
    excludedQuickSorts: [
        'uncategorised',
        'newlyCreated',
        'invalidLink',
        'highPrice',
        'lowPrice',
        'alphabetical',
        'updated',
    ],
    hideContactArchiPro: true,
};

export { loader };
export default NetworkPage;
